<script setup>
    import Dialog from 'primevue/dialog';
    import Button from 'primevue/button';
    import { ref, defineProps, defineEmits } from 'vue';

    const visible = ref(true);

    defineProps(['message']);
    const emit = defineEmits(['confirm', 'cancel']);
</script>

<template>
    <Dialog v-model:visible="visible" modal header="Вопрос" style="max-width: 70%" @hide="emit('cancel')">
        <div class="p-dialog-content pt-3" style="min-width: 25rem;">
            <div class="flex">
                <div class="flex align-items-center justify-content-center m-1">
                    <i class="pi pi-question-circle" style="font-size: 4rem;" ></i>
                </div>
                <div class="flex align-items-center justify-content-centerm-2 px-5 py-2">
                    {{ message }}
                </div>
            </div>
        </div>

        <div class="p-dialog-footer pb-0" style="text-align: center;">
            <Button @click="emit('confirm')" style="width: 6rem; display: table-cell; vertical-align: middle;" >Да</Button>
            <Button @click="emit('cancel')" style="width: 6rem; display: table-cell; vertical-align: middle;" >Нет</Button>
        </div>
    </Dialog>
</template>
